/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import { Input, Label } from "reactstrap";
import Button from "components/CustomButtons/Button.js";
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import TSSelect2 from "components/Forms/TSSelect2";
import Timeline from '@material-ui/lab/Timeline';

import { Collapse, Modal, ModalBody } from "reactstrap";

///object ที่กำหนด styles ต่างๆ
const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    },
    paper: {
        padding: '6px 16px',
    },
    secondaryTail: {
        backgroundColor: "gray",
    },
};

const primaryColor = "#af2cc5";

//object ที่กำหนด styles โดยใช้ makeStyles จาก Material-UI
const useStyles = makeStyles((theme) => ({
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    },
    paper: {
        padding: '6px 16px',
    },
    secondaryTail: {
        backgroundColor: theme.palette.secondary.main,
    },
    largeAvatar: {
        width: theme.spacing(7),
        height: theme.spacing(7),
    },
}));

const Request = (props) => {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));

    const { location, ...other } = props;
    const user = useSelector((state) => state.auth.user);
    const history = useHistory();

    const _refundRequestID = (location.state != null && (location.state.refundRequestID != null && location.state.refundRequestID != '')) ? location.state.refundRequestID : null;

    var moment = require('moment');
    require('moment/locale/th');

    //ประกาศตัวแปร ใช้ useState hook
    const [refundRequestID, setRefundRequestID] = useState('');
    const [RefundReason, setRefundReason] = useState("");
    const [currentDt, setcurrentDt] = useState("");
    const [ContactAddress, setAddress] = useState('');
    const [Phone, setPhone] = useState('');
    const [UserName, setUserName] = useState('');
    const [Profile, setProfile] = useState([]);

    //const [isEditing, setIsEditing] = useState(false);
    const [ArrGroupworkBoss, setArrGroupworkBoss] = useState([]);
    const [ArrMissionBoss, setArrMissionBoss] = useState([]);
    const [ArrDepartmentBoss, setArrDepartmentBoss] = useState([]);
    const [DepartmentBoss, SetDepartmentBoss] = useState("");
    const [GroupworkBoss, SetGroupworkBoss] = useState("");
    const [MissionBoss, SetMissionBoss] = useState("");
    const [ArrStandin, setArrStandin] = useState([]);
    const [Finance, setFinance] = useState([]);;

    const [FlowLevel, setFlowLevel] = useState([]);

    const [modalError, setModalError] = useState(false);
    const [modalCancel, setModalCancel] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [isCancel, setIsCancel] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);

    const [RefundApprove, setRefundApprove] = useState([]);

    const [icon, setIcon] = useState("far fa-question-circle");
    const [icon2, setIcon2] = useState("far fa-question-circle");

    if (location.state) {
        console.log('Location state:', location.state);
        // สามารถเข้าถึง RefundRequestID ได้ที่ location.state.RefundRequestID
        const refundRequestID = location.state.RefundRequestID;
        console.log('RefundRequestID:', refundRequestID);
    } else {
        console.log('No location state available');
    }

    const isEdit = (_refundRequestID != null);

    useEffect(() => {

        console.log(_refundRequestID);
        if (_refundRequestID != null && _refundRequestID != '') {
            props.history.push({
                pathname: '/refund/request',
                state: {
                    refundRequestID: _refundRequestID
                }
            })
        }

        axios.post("/api/v1/currentdate").then(
            (result) => {
                setcurrentDt(result.data.currentDatetime);
            },
            (error) => {
                console.log(error);
            }
        );

        if (currentUser.userID) {
            axios.get(`/api/v1/user/${currentUser.userID}`).then(
                (result) => {
                    setPhone(result.data.data.mobilePhone);
                    setAddress(result.data.data.address);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
        axios.post("/api/v1/team", {RefundRequestID: isEdit ? location.state.refundRequestID: '00000000-0000-0000-0000-000000000000' })
        .then(
        result => {
            var json = JSON.parse(JSON.stringify(result.data.data)/*.split('"firstName":').join('"label":').split('"userName":').join('"value":')*/);
            
            const myteam = json.map((o) => ({
              ...o,
              value: o.userName.toLowerCase(),
              label: `${o.userProfile.firstName} ${o.userProfile.lastName}`
            }));
            
            const jsonMy = myteam.filter(e => e.userName.toLowerCase() == result.data.userName.toLowerCase() && e.isDefault)[0];
            console.log(jsonMy);

            if(!isEdit){
                setPhone(jsonMy.userProfile.mobilePhone);
                setAddress(jsonMy.userProfile.address);
            }
            
            const jsonFinance =  myteam.filter(e => e.userName != result.data.userName && e.departmentKey == 157)
            setFinance(jsonFinance)
         

        }, error => { console.log(error); }
      );  

      axios.post("/api/v1/myteam", {RefundRequestID: isEdit ? location.state.refundRequestID: '00000000-0000-0000-0000-000000000000' })
        .then(
        result => {
            var json = JSON.parse(JSON.stringify(result.data.data)/*.split('"firstName":').join('"label":').split('"userName":').join('"value":')*/);
            
            const myteam = json.map((o) => ({
              ...o,
              value: o.userName.toLowerCase(),
              label: `${o.userProfile.firstName} ${o.userProfile.lastName}`
            }));

            const jsonMy = myteam.filter(e => e.userName.toLowerCase() == result.data.userName.toLowerCase() && e.isDefault)[0];
            console.log(jsonMy);

            if(!isEdit){
                setPhone(jsonMy.userProfile.mobilePhone);
                setAddress(jsonMy.userProfile.address);
            }

            const jsonDept = myteam.filter(e => e.userName != result.data.userName && e.userLevelKey == 1 && jsonMy.userLevelKey < 1 /*e.userLevelKey == jsonMy.userLevelKey*/)
            setArrDepartmentBoss(jsonDept)

            const jsonGroup = myteam.filter(e => e.userName != result.data.userName && (e.userLevelKey == 2 && e.isDefault) && jsonMy.userLevelKey < 2)
            setArrGroupworkBoss(jsonGroup)

            const jsonMission = myteam.filter(e => e.userName != result.data.userName && (e.userLevelKey == 2 || e.userLevelKey == 3) && jsonMy.userLevelKey < 3)
            setArrMissionBoss(jsonMission)

        }, error => { console.log(error); }
      );  

        if (isEdit) {
            axios({
                method: 'get',
                url: "/api/v1/refund/" + _refundRequestID,
                headers: { 'referpage': '/refund/request/' + _refundRequestID }
            })
                .then(
                    resEdit => {
                        var res = resEdit.data.data;
                        setRefundReason(res.refundDesc);
                        setRefundApprove(res.refundApprove);

                        if(res.refundApprove.find(t => t.approveTypeKey == 4) != null)
                            SetDepartmentBoss(res.refundApprove.find(t => t.approveTypeKey == 4).approveUserName)
          
                          if(res.refundApprove.find(t => t.approveTypeKey == 3) != null)
                            SetGroupworkBoss(res.refundApprove.find(t => t.approveTypeKey == 3).approveUserName)
          
                            if (res.refundApprove.find(t => t.approveTypeKey == 2) != null)
                                SetMissionBoss(res.refundApprove.find(t => t.approveTypeKey == 2).approveUserName)
          

                    },
                    error => {

                    }
                );
        }

    }, []);



    const handleSubmit = evt => {
        evt.preventDefault();
        var cntErr = 0;
        var errMsg = [];
        //ประกาศตัวแปร



        //ถ้าไม่ใส่ข้อความ
        if (RefundReason == '') {
            cntErr += 1;
            //RefundReason เป็นค่าว่าง ฟังก์ชันจะเพิ่มค่า cntErr ขึ้น 1
            //นับจำนวนข้อผิดพลาด
            errMsg.push('กรุณาระบุเหตุผล');
        }
        //กรอกข้อความ
        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        } else {
            setModal(true);
        }
    };
    //ฟังก์ชันนี้ใช้สำหรับการยกเลิกคำร้องการลา
  const handleCancel = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");


    //ส่งคำร้องไปยัง API เพื่อยกเลิกการลา ส่งค่า refundRequestID ที่ได้มาจาก location.state ผ่าน URL.
    axios.put('/api/v1/refund/cancel/' + location.state.refundRequestID, null)
          .then(
              result => {
 
                  if (result.data.result == 200) {
                      setIcon("far fa-question-circle");
                      setModalCancel(false)
                      setModal2(true)
                  }
                  else {
                      setIcon("far fa-question-circle");
                      setModalCancel(false)
                      setErrMsg(result.data.msg)
                      setModalError(true)
                  }

              },
              error => { console.log(error); }
    );  
    
  };

    //จัดการกับการยืนยัน (refund)
    const handleConfirm = evt => {
        //ประกาศฟังก์ชันแบบลูกศร (Arrow Function) 
        //รับพารามิเตอร์หนึ่งตัวคือ evt (ย่อมาจาก event) ใช้สำหรับจัดการกับเหตุการณ์ที่เกิดขึ้น เช่น การคลิกปุ่มส่งข้อมูล
        evt.preventDefault();
        // เรียกใช้เมธอด preventDefault() เพื่อยกเลิกการทำงานเริ่มต้นของเหตุการณ์นั้นๆ 
        //เช่น ถ้าเป็นการส่งแบบฟอร์ม การเรียกใช้ preventDefault() จะป้องกันไม่ให้หน้าเว็บรีเฟรช
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
        //ไอคอนที่แสดงโชว์
        var currentUser = JSON.parse(localStorage.getItem('currentUser'))
        console.log(currentUser);

        const _approve = [];

        var isFirst = false;
        
  
        if (ArrDepartmentBoss.length > 0 && DepartmentBoss != '') {
            if (!isFirst) {
                isFirst = true
                _approve.push({ approveTypeKey: 4, approveUserName: DepartmentBoss, approveStatusKey: 1 })
            }
            else {
                _approve.push({ approveTypeKey: 4, approveUserName: DepartmentBoss })
            }
        }
        
  
        if (ArrGroupworkBoss.length > 0 && GroupworkBoss != '') {
            if (!isFirst) {
                isFirst = true
                _approve.push({ approveTypeKey: 3, approveUserName: GroupworkBoss, approveStatusKey: 1 })
            }
            else {
                _approve.push({ approveTypeKey: 3, approveUserName: GroupworkBoss })
            }
              
        }
       
      
        if (ArrMissionBoss.length > 0) {
            if (!isFirst) {
                isFirst = true
                _approve.push({ approveTypeKey: 2, approveUserName: MissionBoss, approveStatusKey: 1 })
            } else {
                _approve.push({ approveTypeKey: 2, approveUserName: MissionBoss })
            }
              
        }


        //สร้าง object
        var refund = {
            refundDesc: RefundReason,
            createDT: currentDt,
            userName: currentUser.userName,
            contactAddress: ContactAddress,
            contactPhone: Phone,
            refundApprove: _approve,

            //currentUser มันจะเป็นก้อนข้อมูล .userName จะส่งค่าที่เป็น  string
            //userName ในหลังบ้านเป็น string
        };


        //แก้ไข
       
        if(location.state != null && location.state.refundRequestID != null && location.state.refundRequestID != '' && location.state.refundRequestID != undefined) 
            {
            console.log("test");
            console.log(location.state);
            console.log(location.state.refundRequestID);
            // (url,body)
            //ใช้ไลบรารี axios เพื่อส่งคำขอ HTTP แบบ PUT ไปยัง API ที่ระบุด้วย URL
            axios.put('/api/v1/refund/' + location.state.refundRequestID, refund)
                .then(
                    result => {

                        console.log(result)

                        if (result.data.result == 200) {
                            setIcon("far fa-question-circle");
                            setModal(false)
                            setModal2(true)
                            //setIsEdit(true);
                        }
                        else {
                            setIcon("far fa-question-circle");
                            setModal(false)
                            setErrMsg(result.data.msg)
                            setModalError(true)
                        }

                    },
                    error => { console.log(error); }
                );
        }
        else {
            //ข้อมูลใหม่

            axios.post('/api/v1/refund', refund)
                .then(
                    result => {
                        if (result.data.result == 200) {
                            setRefundRequestID(result.data.refundRequestID)
                            setIcon("far fa-question-circle");
                            setModal(false)
                            setModal2(true)
                        }
                        else {
                            setIcon("far fa-question-circle");
                            setModal(false)
                            setErrMsg(result.data.msg)
                            setModalError(true)
                        }

                    },
                    error => { console.log(error); }
                );

        }

    };
    
    // ใช้สำหรับปิด modal และ test ใช้สำหรับเลื่อนหน้าจอไปยังตำแหน่งที่กำหนดโดย ref
    const GotoEdit = evt => {
        evt.preventDefault();
        //ตรวจสอบค่า RefundRequestID
        //ถ้ามี RefundRequestID ใน location.state ฟังก์ชันจะนำไปยังหน้าแก้ไขด้วย RefundRequestID ที่กำหนดใน URL
        if (location.state != null && location.state.refundRequestID != null && location.state.refundRequestID != '') {
            setModal2(false)
            props.history.push({ pathname: '/refund/id/' + location.state.refundRequestID })
        }
        //ถ้าไม่มี RefundRequestID
        //ใช้ props.history.push เพื่อเปลี่ยนเส้นทางไปยัง URL ที่ใช้สำหรับการแก้ไขข้อมูลการขอคืนเงิน โดยใช้ RefundRequestID ที่เก็บไว้ในสถานะปัจจุบัน
        else {
            props.history.push({ pathname: '/refund/id/' + refundRequestID })
        }
    }


    const renderFlowLevel = (approve, index) => {
    
        var flow = FlowLevel.find(t => t.RefundApproveKey == approve.approveTypeKey);
    
        var hr = RefundApprove.find(t => t.RefundApproveKey == 0);
    
        var flowTxt = '';
        var tmpColor = '';
        if(approve.approveStatusKey == null ||approve.approveStatusKey == 0)
        {
          flowTxt = (flow != null) ? flow.flowName : '';  
        }
        else if (approve.approveStatusKey == 1)
        {
          flowTxt = (flow != null) ? 'รอ'+flow.flowName+flow.flowActorName : '';
          tmpColor = '#ff9800';
        }
        else if (approve.approveStatusKey == 2)
        {
            flowTxt = (flow != null) ? flow.flowName+flow.flowFinishName : '';
            tmpColor = '#4caf50';
        }
        else if (approve.approveStatusKey == -1)
        {
          flowTxt = (flow != null) ? flow.flowName+flow.flowRejectName : '';
          tmpColor = '#f44336';
        }
        else{
    
        }
    }

    


    const classes = useStyles();

    return (
        <div>
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>แบบคำขออนุมัติการคืนเงิน</h4>
                            <p className={classes.cardCategoryWhite}> กรุณาระบุรายละเอียด </p>
                        </CardHeader>

                        <CardBody>
                            <Grid>
                                <Col xs={12} sm={12} md={12}>
                                    <div className="textarea-container" style={{ padding: 0 }}>
                                        <Label for="RefundDesc">เหตุผลการคืนเงิน</Label>
                                        <Input
                                            id="RefundReason"
                                            cols="80"
                                            name="RefundReason"
                                            placeholder="เหตุผล"
                                            rows="4"
                                            type="textarea"
                                            className="custom"
                                            style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                            value={RefundReason}
                                            onChange={e => setRefundReason(e.target.value)}
                                        ></Input>
                                    </div>
                                </Col>
                            </Grid>
                            <Col xs={12} sm={12} md={6}>
                            {(ArrDepartmentBoss.length > 0) ?
                                        <TSSelect2 isClearable={true} zIndex={6} label="หัวหน้างาน" options={ArrDepartmentBoss} value={DepartmentBoss} onChange={e => SetDepartmentBoss(e != null ? e.value : '')} />
                                        :
                                        <></>         
                                    }

                                    {(ArrGroupworkBoss.length > 0) ?
                                        <TSSelect2 isClearable={true} zIndex={5} label="หัวหน้ากลุ่มงาน" options={ArrGroupworkBoss} value={GroupworkBoss} onChange={e => SetGroupworkBoss(e!=null?e.value:'') } />
                                        :
                                        <></>
                                    }

                                        <TSSelect2 isClearable={true} zIndex={4} label="การเงิน" options={Finance}  />
                                           

                                    {(ArrMissionBoss.length > 0) ?   
                                        <TSSelect2 isClearable={true} zIndex={3} label="รองภารกิจ" options={ArrMissionBoss} value={MissionBoss} onChange={e => SetMissionBoss(e != null ? e.value : '') } />
                                        :
                                        <></>
                                    }
                            </Col>

                            <Grid><Col>&nbsp;</Col></Grid>
                            <Grid tyle={{ display: isCancel || isEdit || currentUser.userName !== UserName ? '' : 'none' }}>
                                {(location.state != null && location.state !== '' && location.state.refundRequestID != null && location.state.refundRequestID !== '') ?
                                    <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                        <Button color="warning" onClick={handleSubmit} fullWidth>
                                            <i className={"fa fa-edit"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }} ></i>
                                            <h4>แก้ไข</h4>
                                        </Button>
                                    </Col>
                                    :
                                    <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                        <Button color="info" onClick={handleSubmit /*handleConfirmTest*/} fullWidth>
                                            <i className={"fa fa-save"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }} ></i>
                                            <h4>บันทึก</h4>
                                        </Button>
                                    </Col>
                                }
                                <Col xs={12} sm={12} md={2} >
                                  <>&nbsp;</>             
                                </Col>

                                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                    <Button color="danger" onClick={() => { setModalCancel(true); }} fullWidth>
                                              <h4>ยกเลิก</h4>
                                  </Button>
                                </Col>
                            </Grid>
                            <Grid style={{ display: ((isCancel) ? '' : 'none') }}>
                                <Col xs={12} sm={12} md={12} style={{ background: 'red' }} >
                                    
                                    <h4 style={{color:'white', fontSize:'24px', textAlign:'center'}}>ยกเลิกการคืนเงิน</h4>
                                   
                                </Col>
                            </Grid>

                        </CardBody>

                        <CardFooter>
                            {/* Confirm */}
                            <Modal toggle={() => { setModal(false); setIcon("far fa-question-circle"); }} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="info"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setModal(false); setIcon("far fa-question-circle"); }}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>
                                </div>
                            </Modal>

                            <Collapse isOpen={isOpen}></Collapse>
                            {/* Success */}
                            <Modal toggle={GotoEdit} isOpen={modal2}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={"fas fa-check"}
                                            style={{ color: "green", fontSize: "4em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        บันทึกข้อมูลสำเร็จ
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="info"
                                        type="button"
                                        onClick={GotoEdit}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ตกลง</h4>
                                    </Button>
                                </div>
                            </Modal>
                            {/* Cancel */}
                            <Modal toggle={() => setModalCancel(false)} isOpen={modalCancel}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันยกเลิกการคืนเงิน"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">

                                    <Button
                                        color="success"
                                        type="button"
                                        onClick={handleCancel}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setIcon("far fa-question-circle"); setModalCancel(false); }}
                                    >
                                        <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ปฏิเสธ</h4>
                                    </Button>


                                </div>
                            </Modal>

                            {/* Error */}
                            <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className="fa fa-times"
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                    <i
                                        className="fa fa-cogs"
                                        style={{ color: "red", fontSize: "2em" }}
                                    ></i>
                                    {/*<div id='errMsg'>{errMsg}</div>*/}
                                    <div dangerouslySetInnerHTML={{ __html: errMsg }} />
                                </ModalBody>
                                <div className="modal-footer justify-content-center">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModalError(false)}
                                    >
                                        <h4>ตกลง</h4>
                                    </Button>
                                </div>
                            </Modal>
                        </CardFooter>
                    </Card>
                    <Card style={{display: ((isEdit && !isCancel) ? '' : 'none')}}>
                        <CardHeader color="primary">

                            <h4 className={classes.cardTitleWhite}>ติดตามสถานะ การคืนเงิน</h4>
                            <p className={classes.cardCategoryWhite}> </p>

                        </CardHeader>

                        <CardBody>
                            
                            <Grid>
                                <Col xs={12} sm={12} md={12} key={1} >
                                  <Timeline align="alternate">                                 
                                    {/* {
                                      LeaveApprove.map((item, index) => (
                                          (item.approveTypeKey != 0 || true ) ?
                                        renderFlowLevel(item, index)
                                        :
                                        <p></p>
                                    ))} */}

                                  </Timeline>
                                </Col>
                            </Grid>
                        </CardBody>
                  </Card>
                </Col>
            </Grid>
        </div>
    );
}
export default Request;
